import React, { useEffect } from 'react';
import { Button, Stack } from 'react-bootstrap';
import { getCurrencySymbol } from 'utils';
import { setIsLoading } from 'store/common';
import { logPurchaseStarted, useGetStripPaymentURLMutation } from 'services';
import { APP_BASE_URL } from 'constants';
import useTranslate from 'hooks/useTranslate';
import './styles.scss';

const SubscriptionPlan: React.FC<any> = ({ plan }) => {
	const { translate } = useTranslate();
	const {
		id = null,
		title = '',
		description = '',
		price = 0,
		default_currency = '',
		no_of_jobs = 0,
		no_of_meeting = 0,
		no_of_profile_view = 0,
		no_of_contact = 0,
		no_of_job_application = 0,
		duration = 0,
		isAlreadyPurchased = false,
	} = plan;

	const { mutateAsync: stripePaymentURL } = useGetStripPaymentURLMutation();

	useEffect(() => {
		sessionStorage.removeItem('redirectURL');
	}, []);

	const buySubscription = () => {
		logPurchaseStarted(id);
		setIsLoading(true);
		sessionStorage.setItem('redirectURL', location?.pathname?.replace(APP_BASE_URL, ''));
		stripePaymentURL({ planId: Number(id) })
			.then((res: any) => {
				if (res?.success && res?.data?.url) {
					window.open(res?.data?.url, '_self');
				}
			})
			.finally(() => {
				setIsLoading(false);
			});
	};

	return (
		<>
			<Stack className="subscription-plan">
				<div className="package-detail">
					<h5 className="mb-1">{title}</h5>
					<p className="mb-0">{description}</p>
					<div className="package-price">
						<h3 className="mb-0">
							{default_currency && getCurrencySymbol(default_currency)}
							{price}
						</h3>
					</div>
				</div>
				<hr></hr>
				<div className="features-detail">
					<h6 className="fw-bold">{translate('Common.features')}</h6>
					<Stack className="features-list">
						{Number(duration) > 0 && (
							<div className="d-flex align-items-center">
								<i className="ri-checkbox-circle-line"></i>
								<h6 className="mb-0">{translate('Common.planPeriod', { months: duration })}</h6>
							</div>
						)}

						{Number(no_of_jobs) > 0 && (
							<div className="d-flex align-items-center">
								<i className="ri-checkbox-circle-line"></i>
								<h6 className="mb-0">
									{translate('Common.jobPostingCount', { number: no_of_jobs })}
								</h6>
							</div>
						)}

						{Number(no_of_contact) > 0 && (
							<div className="d-flex align-items-center">
								<i className="ri-checkbox-circle-line"></i>
								<h6 className="mb-0">
									{translate('Common.chatWithNumber', { number: no_of_contact })}
								</h6>
							</div>
						)}

						{Number(no_of_meeting) > 0 && (
							<div className="d-flex align-items-center">
								<i className="ri-checkbox-circle-line"></i>
								<h6 className="mb-0">
									{translate('Common.scheduleMeetingNumber', { number: no_of_meeting })}
								</h6>
							</div>
						)}

						{Number(no_of_job_application) > 0 && (
							<div className="d-flex align-items-center">
								<i className="ri-checkbox-circle-line"></i>
								<h6 className="mb-0">
									{translate('Common.applyOnJobsNumber', { number: no_of_job_application })}
								</h6>
							</div>
						)}

						{Number(no_of_profile_view) > 0 && (
							<div className="d-flex align-items-center">
								<i className="ri-checkbox-circle-line"></i>
								<h6 className="mb-0">
									{translate('Common.viewProfilesNumber', { number: no_of_profile_view })}{' '}
								</h6>
							</div>
						)}
					</Stack>
				</div>
				<Button
					onClick={() => (!isAlreadyPurchased ? buySubscription() : {})}
					className="filled-btn rounded-pill w-100 mt-auto"
					disabled={isAlreadyPurchased}
				>
					{isAlreadyPurchased ? translate('Button.purchased') : translate('Button.buyNow')}
				</Button>
			</Stack>
		</>
	);
};

export default SubscriptionPlan;
